import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRoutingModule } from './user-routing.module';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthLoginService } from './services/auth-login.service';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { SharedModule } from '../shared/shared.module';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedEffects } from '../shared/store/effects/shared.effects';
import * as fromShared from '../shared/store/reducers';

@NgModule({
  declarations: [SignInComponent, ForgotPasswordComponent, SignUpComponent, ThankYouComponent, MaintenanceComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    UserRoutingModule,
    SharedModule,
    NgcCookieConsentModule,
    StoreModule.forFeature(fromShared.sharedFeatureKey,fromShared.sharedReducer),
    EffectsModule.forFeature([SharedEffects])
  ]
  ,
  providers: [
    AuthLoginService
  ],
})
export class UserModule { }
